interface PostFilter {
    checked: boolean;
    minPrice: number;
}

export type FilterState<T> = Partial<T> & { available: boolean };

export type AvailablePostFilter<T> = T & { available: boolean };

export interface TourOperatorFilter extends PostFilter {
    name: string;
    id: number;
    availableForOnlineBilling: boolean;
}

export interface RoomTypeFilter extends PostFilter {
    name: string;
}

export interface MealTypeFilter extends PostFilter {
    code: string;
    name: string;
}

export interface DepartDateFilter extends PostFilter {
    date: string; // DD.MM.YYYY
    day: string;
    month: string;
    weekDay: string;
    isWeekend: boolean;
    minPricePerDay: number;
}

export interface NightsFilter extends PostFilter {
    count: number;
}

export interface PostFilters {
    tourOperators: TourOperatorFilter[];
    roomTypes: RoomTypeFilter[];
    mealTypes: MealTypeFilter[];
    departDates: DepartDateFilter[];
    nights: NightsFilter[];
    availableForOnlineBillingOperators?: TourOperatorFilter[];
}

export enum TabsType {
    RoomTypes = 'room-types',
    MealTypes = 'meal-types',
    OnlineBilling = 'online-billing',
    TourOperators = 'touroperators',
    DepartDates = 'depart-dates',
    Nights = 'nights-count'
}

// TODO selkin: нужно подумать как можно через P in keyof T с помощью generic решить
export interface AvailablePostFilters {
    tourOperators: AvailablePostFilter<TourOperatorFilter>[];
    roomTypes: AvailablePostFilter<RoomTypeFilter>[];
    mealTypes: AvailablePostFilter<MealTypeFilter>[];
    departDates: AvailablePostFilter<DepartDateFilter>[];
    nights: AvailablePostFilter<NightsFilter>[];
}
